/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MovePromptCodeDown$Params {
  promptCodeID?: number;
}

export function MovePromptCodeDown(http: HttpClient, rootUrl: string, params?: MovePromptCodeDown$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, MovePromptCodeDown.PATH, 'post');
  if (params) {
    rb.query('promptCodeID', params.promptCodeID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

MovePromptCodeDown.PATH = '/api/Supervisor/MovePromptCodeDown';
